export default __webpack_public_path__ + "maps-examples-view-annotation-basic-thumbnail-960-0cba2dfb7b79d9751a7f05381d8101e2.png";